import { dispatch } from 'index'

export const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) return response
  const error = new Error(response.statusText)
  error.response = response

  if (response.status === 401) {
    dispatch({ type: 'UNAUTHORIZED' })
  }
  throw error
}

export const checkStatusForLogin = (response) => {
  if (response.status >= 200 && response.status < 300) return response
  const error = new Error(response.statusText)
  return response.json().then((res) => {
    error.response = res.error
    throw error
  })
}
